import { motion } from "framer-motion";
import { MessageCircle, FileSearch, Wrench, PowerCircle } from "lucide-react";

const steps = [
  {
    icon: MessageCircle,
    title: "Beratung",
    desc: "Kostenlose Erstberatung vor Ort oder digital. Wir verstehen Ihren Bedarf.",
  },
  {
    icon: FileSearch,
    title: "Planung",
    desc: "Detailplanung, Ertragsprognose und transparente Offerte – inkl. Förderung.",
  },
  {
    icon: Wrench,
    title: "Installation",
    desc: "Saubere Montage durch unsere Solarteure. Meist in 2–4 Tagen abgeschlossen.",
  },
  {
    icon: PowerCircle,
    title: "Inbetriebnahme",
    desc: "Anschluss, Monitoring-App und Übergabe. Ab jetzt produzieren Sie eigenen Strom.",
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="text-sm text-[#EAB308] font-semibold uppercase tracking-widest">
            Unser Prozess
          </div>
          <h2 className="mt-3 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1D20]">
            Von der Idee zur eigenen Stromfabrik.
          </h2>
          <p className="mt-4 text-[#4B5563]">
            In 4 klar definierten Schritten – ohne Überraschungen, mit fixem
            Ansprechpartner.
          </p>
        </div>

        <div className="relative">
          {/* Glowing line */}
          <div className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px process-line" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4 relative">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  data-testid={`process-step-${i}`}
                  className="relative flex flex-col items-center text-center md:px-3"
                >
                  <div className="relative">
                    <div className="absolute inset-0 sun-ring rounded-full" />
                    <div className="relative w-24 h-24 rounded-full bg-white border border-[#EAB308]/30 flex items-center justify-center shadow-[0_8px_24px_-12px_rgba(234,179,8,0.45)]">
                      <Icon className="text-[#1A1D20]" size={28} />
                    </div>
                    <div className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-[#1A1D20] text-[#EAB308] font-display font-bold flex items-center justify-center text-sm">
                      {i + 1}
                    </div>
                  </div>
                  <h3 className="mt-5 font-display font-semibold text-xl text-[#1A1D20]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#4B5563] max-w-[220px]">
                    {s.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
